import { safeMapUrl } from './location-schema';
import type { CalendarEvent } from './contracts';
export function locationMapLinks(location: NonNullable<CalendarEvent['physicalLocation']>) {
  const provided = safeMapUrl(location.mapUrl);
  const query = location.address.trim() || location.name.trim();
  const url = provided ? new URL(provided) : null;
  const googleProvided =
    url &&
    ['google.com', 'www.google.com', 'maps.google.com', 'maps.app.goo.gl'].includes(url.hostname)
      ? provided
      : undefined;
  const appleProvided =
    url && (url.hostname === 'maps.apple.com' || url.hostname === 'maps.apple')
      ? provided
      : undefined;
  return {
    google:
      googleProvided ||
      (query
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
        : undefined),
    apple:
      appleProvided ||
      (query ? `https://maps.apple.com/?q=${encodeURIComponent(query)}` : undefined),
    provided: provided && !googleProvided && !appleProvided ? provided : undefined,
  };
}
export function prefersAppleMaps(userAgent: string, platform = '') {
  return /iPhone|iPad|iPod|Macintosh/.test(userAgent) || /^Mac/.test(platform);
}
